module.exports = __webpack_public_path__ + "static/media/map-area.7351772b.svg";